import React from 'react';
import { ActivityIndicator, FlatList } from "react-native"
import MarketsCard from "./MarketsCard"
import type { AthleteProps, CompetitionMatchMarketProps, CompetitionMatchProps, CompetitionProps, CompetitionTypeProps, EventProps, MarketProps, PlayerPickProps } from '../../types';
import moment from 'moment-mini';
import { CompetitionHelpers, FINALIZED_STATUSES } from '../api';
import Colors from '../../constants/colors';
import LinearDiagnal from '../../Components/LinearDiagnal';
import { AthleteImage } from '../../Components/Jerseys';
import { Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type AthleteMarketCardProps = {
    competition:CompetitionProps,
    competition_type:CompetitionTypeProps,
    event:EventProps,
    markets:MarketProps[],
    athlete:AthleteProps,
    onPick:(pp:PlayerPickProps, event_title:string, event_start:string) => void
    mode: 'view'|'play'
    loading?:boolean,
    orientation:'horizontal'|'vertical',
    player_picks:PlayerPickProps[],
    competition_match:CompetitionMatchProps,
    competition_match_markets:CompetitionMatchMarketProps[]
}

const AthleteMarketCard = ({  markets, competition_type, event, athlete, mode, loading, player_picks, orientation, competition_match, competition_match_markets, onPick }:AthleteMarketCardProps) => {
    const C = useColors();
    const market = markets.find(m => m.market_id == competition_match.market_id_override)
    const wager_picks = player_picks.filter(pp => pp.stake > 0)

    const handleMarketSelect = async(mm:CompetitionMatchMarketProps, player_pick?:PlayerPickProps) => {
        let market = markets.find(m => m.market_id == mm.market_id)
        if(!event || !competition_type || !market){ return alert('Unable to process') }
        if(moment(event.scheduled_datetime).isBefore(moment())){ return alert('This event has already started') }
        if(player_pick){
            return onPick(player_pick, event.event_title, event.scheduled_datetime)
            //await CompetitionStoreActions.removePlayerPick(player_pick.player_pick_id)
        } else {
            let pp = CompetitionHelpers.createPickFromMatchMarket(competition_match.competition_id, mm)
            let pick_title = CompetitionHelpers.getPickTitleForTeamEvent(pp, market, event, athlete)
            return onPick({ ...pp, pick_title }, event.event_title, event.scheduled_datetime)
        }
    }

    const renderWagerPicks = (data: { item:PlayerPickProps, index:number }) => {
        const locked = mode == 'view' && moment().isBefore(moment(event.scheduled_datetime)) ? true : false
        return (
            <View style={{ flexDirection:'row', marginTop:5 }}>
                <Text style={{ flex:1 }} size={12} color={C.text.highlight}>{locked?'WAGER LOCKED':data.item.pick_title}</Text>
                <Text style={{ flex:1 }} size={12} color={C.text.highlight} textAlign="right">{locked?'':`${data.item.stake.toFixed(2)} to win ${data.item.potential_winnings.toFixed(2)}`}</Text>
            </View>
        )
    }

    if(!athlete){ return <></> }
    return (
        <View transparent>
            {market ?
                <LinearDiagnal 
                label={market.stat_label ?? market.type}
                label_size={10}
                style={{ borderTopLeftRadius:8 }}
                left_color={C.text.gold}
                right_color={'#ebd197'}
            />
            :<></>}
            <View transparent style={{ padding:10, flex:1, flexDirection:orientation=='horizontal'?'row':'column', alignItems:orientation=='horizontal'?'center':undefined }}>
                
                <View transparent nativeID="event_details" style={{ flexGrow:1, flexDirection:orientation=='horizontal'?'row':'column', alignItems:'center' }}>
                    <View transparent nativeID="athlete_image" style={{ flexGrow:1 }}>
                        <AthleteImage athlete={athlete} size={48} number_size={10}/>
                    </View>
                    <View transparent>
                        <Text size={16} theme='h1' textAlign="center">{athlete.first_name} {athlete.last_name}</Text>
                        <Text style={{ marginTop:3 }} theme='description' textAlign="center">{athlete.team ? `${athlete.team.abbr} (${athlete.position})`:`${athlete.position}`}</Text>
                    </View>
                </View>
                <View style={{ flex:1 }} />
                <View transparent nativeID="market_details" style={{flex:orientation=='horizontal'?1:undefined, margin:5 }}>
                    {orientation == 'horizontal' && market ?
                    <Text style={{ margin:2 }} size={14} color={Colors.shades.black} textAlign="center">{market.description}</Text>
                    :<></>}
                    <MarketsCard
                        player_picks={player_picks}
                        mode={mode}
                        markets={markets}
                        orientation="horizontal"
                        disabled={moment().isAfter(moment(event.scheduled_datetime)) || FINALIZED_STATUSES.includes(event.status) ? true : false}
                        locked={mode == 'view' && moment().isBefore(moment(event.scheduled_datetime)) ? true : false}
                        competition_match_markets={competition_match_markets}
                        onMarketSelect={(mm, player_pick) => handleMarketSelect(mm, player_pick)}
                    />
                    {loading ?
                    <View type='blur' style={{ position:'absolute', top:0, right:0, left:0, bottom:0, justifyContent:'center', alignItems:'center' }}>
                        <ActivityIndicator
                            size='large'
                            color={C.text.h1}
                        />
                    </View>
                    :<></>}
                </View>
            </View>
            {wager_picks.length > 0 ?
            <View transparent nativeID="wager_picks">
                <FlatList
                    data={wager_picks}
                    renderItem={renderWagerPicks}
                    keyExtractor={(item) => item.player_pick_id.toString()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default AthleteMarketCard